<tt-page>
    <tt-card>
        <input #fileInput type="file" hidden (change)="fileChanged($event)" />
        <tt-button ttText="csvimport_select_file" (ttClick)="selectFile()" [ttLoading]="loadingFile" ttIcon="fas fa-sync"></tt-button>
    </tt-card>
</tt-page>
